<template>
    <div style="margin-left: 30px;" v-loading="loading">
        <div style="margin-bottom: 20px;text-align: center">
            <el-menu style="margin-top: -20px;" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                     @select="handleOpen">
                <el-menu-item index="0">
                    <span>基本设置</span>
                </el-menu-item>
                <el-menu-item index="2" router="true">
                    <span slot="title">车厢下载设置</span>
                </el-menu-item>
                <el-menu-item index="4">
                    <span>校网通管理中心</span>
                </el-menu-item>
                <el-menu-item index="1">
                    <span>学校风险控制</span>
                </el-menu-item>
                <el-menu-item >
                    <a href="https://www.21cnjy.com/xwt/error-code" target="_blank">下载异常查询</a>
                </el-menu-item>
                <el-menu-item index="3">
                    <span>修改记录</span>
                </el-menu-item>
                <el-tooltip class="item" effect="light" placement="left" :value=true>
                    <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i> 修改配置后请点击此处保存</b> </div>
                    <TemporaryLimit v-if="is_temporary" style="text-align: center;float: right;margin-top: 26px" buttonName="确定" @change="submit"></TemporaryLimit>
                    <el-button v-else style="text-align: center;float: right;margin-top: 26px" size="small" type=primary @click="submit()">确定</el-button>
                </el-tooltip>
            </el-menu>
        </div>
        <div v-show="activeIndex==0" style="margin-top: 10px">
            <product-head style="margin-left: 120px;" :params="params" @changeHead="changeHead"></product-head>
            <div>
                <el-form>
                    <el-form-item label="校本资源库产品时间：" label-width="203px" style="color:red;">
                        {{form.jb3_start_at}} ~ {{form.jb3_end_at}}
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div v-show="activeIndex==1">
            <label style="color: #001528">日下载次数设置</label>
            <el-form :model="form" :rules="rules" label-width="100px" ref="form" class="service-time">
                <el-form-item label="下载次数限制：" label-width="203px" class="limit-configure">
                    总：
                    <el-input v-model="form.day_time_setting.all" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerQuotaConsumption','total_quota')}}</span>
                    普：
                    <el-input v-model="form.day_time_setting.pu" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerQuotaConsumption','ordinary_quota')}}</span>
                    精：
                    <el-input v-model="form.day_time_setting.jing" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerQuotaConsumption','fine_quota')}}</span>
                    特：
                    <el-input v-model="form.day_time_setting.te" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerQuotaConsumption','special_quota')}}</span>
                </el-form-item>
                <el-form-item label="单个账号下载次数限制：" label-width="203px" prop="single_account_time_setting" class="limit-configure">
                    总：
                    <el-input v-model="form.single_account_time_setting.all" type="number"  :size="input_size"></el-input>
                    普：
                    <el-input v-model="form.single_account_time_setting.pu" type="number" :size="input_size"></el-input>
                    精：
                    <el-input v-model="form.single_account_time_setting.jing" type="number" :size="input_size"></el-input>
                    特：
                    <el-input v-model="form.single_account_time_setting.te" type="number" :size="input_size"></el-input>
                </el-form-item>
            </el-form>
            <label style="color: #001528">学币使用设置</label>
            <el-form :model="form" label-width="100px" ref="form1" class="service-time">
                <el-form-item label="充值学币数量：" label-width="203px" class="limit-configure">
                    <el-input v-model="form.coin_setting.sums" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','total_coin')}}</span>
                    精：<el-input v-model="form.coin_setting.jing" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','fine_coin')}}</span>
                    普：<el-input v-model="form.coin_setting.pu" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','ordinary_coin')}}</span>
                    特：<el-input v-model="form.coin_setting.te" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','special_coin')}}</span>
                </el-form-item>
                <el-form-item label="单个账号使用学币数量：" label-width="203px" prop="account" class="limit-configure">
                    <el-input v-model="form.single_coin_setting.sums" type="number" :size="input_size"></el-input>
                    精：<el-input v-model="form.single_coin_setting.jing" type="number" :size="input_size"></el-input>
                    普：<el-input v-model="form.single_coin_setting.pu" type="number" :size="input_size"></el-input>
                    特：<el-input v-model="form.single_coin_setting.te" type="number" :size="input_size"></el-input>
                </el-form-item>
            </el-form>
            <label style="color: #001528">总下载次数设置</label>
            <el-form :model="form" label-width="100px" ref="form1" class="service-time">
                <el-form-item label="下载次数限制：" label-width="203px" class="limit-configure">
                    总：
                    <el-input v-model="form.day_time_all_setting.all" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','total_num')}}</span>
                    普：
                    <el-input v-model="form.day_time_all_setting.pu" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','ordinary_num')}}</span>
                    精：
                    <el-input v-model="form.day_time_all_setting.jing"  type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','fine_num')}}</span>
                    特：
                    <el-input v-model="form.day_time_all_setting.te" type="number" :size="input_size"></el-input>
                    <span style="color: red;">{{getConsumption('customerCoinConsumption','special_num')}}</span>
                </el-form-item>
                <el-form-item label="单个账号下载次数限制：" label-width="203px" prop="single_account_time_setting" class="limit-configure">
                    总：
                    <el-input v-model="form.single_account_time_all_setting.all" type="number"  :size="input_size"></el-input>
                    普：
                    <el-input v-model="form.single_account_time_all_setting.pu" type="number" :size="input_size"></el-input>
                    精：
                    <el-input v-model="form.single_account_time_all_setting.jing" type="number" :size="input_size"></el-input>
                    特：
                    <el-input v-model="form.single_account_time_all_setting.te" type="number" :size="input_size"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div v-show="activeIndex==2">
            <label style="color: #001528">
                <el-button type="info" size="mini" @click="addBox()">添加车厢
                </el-button>
            </label>
            <el-alert
                title="警告提示"
                type="warning"
                description="学校日下载总次数限制上限为500，若存在多个车厢，则多个车厢日下载总次数限制合计为500；培训机构日下载总次数限制为一年校网通价格/20，且培训机构账号不能超过规定标准（注：代理订单需在【学校风险控制】处填写单个账号下载次数限制总数为100）"  
                close-text="朕知道了" 
                show-icon>
            </el-alert>
            <el-tabs style="margin-top: 10px;" v-model="currentOption" v-if="options.length>0" type="card" closable
                     @tab-click='tabClick' @tab-remove="removeBox">
                <el-tab-pane
                        v-for="(item) in options"
                        :key="item.id"
                        :name="item.id"
                >
                    <span slot="label">({{item.id}}){{item.name}}</span>
                </el-tab-pane>
                <keep-alive>
                    <component :ref="currentOption" :is="currentView" :params="params" :key="currentOption" @updateBoxForm="updateBoxForm"
                               :box_id="currentOption"></component>
                </keep-alive>
            </el-tabs>
        </div>
        <div v-if="activeIndex==3">
            <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
        </div>

        <div v-show="activeIndex==4">
            <p>
                <b>（注：校网通中心的使用期限与校网通产品的时间一致）</b>
            </p>
            <MenuBind :customer_id="$route.query['id']" :product_id="form.product_id"></MenuBind>
        </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>


<script>
    import CustomerGroupService from "~/services/customerGroup";
    import ProductHead from "~/views/order/partial/product_head.vue";
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import xwtLog from "~/views/log/xwt.vue";
    import Recorder from "~/views/order/recoder/base.vue";
    import xwtBox from "~/views/order/xwtBox.vue";
    import OrderService from "~/services/order";
    import Params from "~/config/params";
    import MenuBind from "~/views/customer/menu/MenuBind.vue";
    import TemporaryLimit from "~/views/order/dialog/temporaryLimit.vue";
    export default {
        components: {
            ProductHead,
            RelationDialog,
            xwtLog,
            xwtBox,
            Recorder,
            MenuBind,
            TemporaryLimit
        },
        data() {
            let checkNumber = (rule, value, callback) => {
                console.log(value);
                if (!value['all']) {
                    callback(new Error('请设置总额度'));
                }
                if (value['all']==0) {
                    callback(new Error('总额度不能为0'));
                }
                callback();
            }
            return {
                activeIndex: '2',
                currentView: 'xwtBox',
                loading: true,
                input_size: 'mini',
                check_box_config:false,
                form: { //车厢表单
                    order_id: '',
                    product_id: '',
                    consumption:'',
                    consumption_all:'',
                    coin_setting: { //学币使用设置之充值学币设置
                        sums: 0,
                        jing:0,
                        pu:0,
                        te:-1
                    },
                    single_coin_setting: { //学币使用设置之单个账号学币设置
                        sums: 0,
                        jing:0,
                        pu:0,
                        te:-1
                    },
                    day_time_setting: { //日下载次数之下载次数设置
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: 0
                    },
                    single_account_time_setting: { //日下载次数之单个账号下载次数限制
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: 0
                    },
                    day_time_all_setting: { //总下载次数之下载次数设置
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: 0
                    },
                    single_account_time_all_setting: { //总下载次数之单个账号下载次数限制
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: 0
                    },
                    box_setting: '',//车厢设置
                    expire_type: ''
                },
                rules:{
                    'single_account_time_setting': [
                        {validator: checkNumber, trigger: 'blur'},
                    ],
                },
                currentOption: '',
                formLabelWidth: '0px',
                dialogFormVisible: false,
                options: [],
                isFormModified: false,
                is_temporary: false,
            };
        },
        props: {
            params: {
                required: true
            }
        },

        created() {
            this.getOptions();
            this.form = Object.assign(this.form, this.params.config);
            this.form.order_id = this.params.order_id;
            this.form.product_id = this.params.product_id;
            this.form.type = this.params.open_state;
            this.form.end_at = this.params.end_at;
            this.form.start_at = this.params.start_at;

            setTimeout(() => {
                this.isFormModified = true;
            });
        },

        watch: {
            'form.coin_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
            'form.single_coin_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
            'form.day_time_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
            'form.single_account_time_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
            'form.day_time_all_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
            'form.single_account_time_all_setting': {
                handler(newVal, oldVal) {
                    this.watchForm(newVal, oldVal);
                },
                deep: true, // 深度监听，确保内部属性变化也能触发
            },
        },
        
        methods: {
            watchForm(newVal, oldVal){
                if (this.isFormModified) {
                    // 只有当 isFormModified 为 true 时，才认为这是用户修改
                    console.log('修改监听:', newVal, oldVal);
                    // 在这里执行你需要的操作，比如更新其他数据或调用方法
                    this.is_temporary = true;
                }else{
                    console.log('初始化:', newVal, oldVal);
                }
            },

            getConsumption(type,key){
               if(!this.form.consumption[type]) return 0;
                return this.form.consumption[type][key]?this.form.consumption[type][key]:0;
            },
            handleOpen(key, keyPath) {
                if(key==1){
                    this.$message({
                        message:'学校额度下载设置”主要起学校风险控制作用没有特殊需求可以无须进行设置，直接点击“用户组额度”设置即可',
                    });
                }
                this.activeIndex = key;
            },
            tabClick($event) {
                this.currentOption = $event.name;
            },
            handleClose(data) {
                console.log(data)
            },
            /**
             * 修改头部信息（开通时间及产品类型）
             * */
            changeHead(data) {
                this.form.type = data.type;
                this.form.start_at = data.start_at;
                this.form.end_at = data.end_at;
                this.form.coin_setting.memo = data.memo;
            },
            removeBox(targetName) {
                let tabs = this.options;
                let currentTab = tabs.find(i => {
                    return i.id == targetName
                });
                this.$confirm('此操作将永久删除车厢(' + currentTab.name + '), 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    let activeName = this.currentOption;
                    let activeBoxId = this.currentOption;
                    if (activeName === targetName) {
                        tabs.forEach((tab, index) => {
                            if (tab.id === targetName) {
                                let nextTab = tabs[index + 1] || tabs[index - 1];
                                if (nextTab) {
                                    activeBoxId = nextTab.id;
                                }
                            }
                        });
                    }
                    this.currentOption = activeBoxId;
                    CustomerGroupService.deleteGroup({
                        id: targetName,
                        customer_id: this.params.customer_id
                    }).then(res => {
                        if (res.code == 0) {
                            this.currentOption = activeBoxId;
                            this.options = tabs.filter(tab => tab.id != targetName);
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    });
                });
            },
            addBox() {
                this.$prompt('请输入用户组名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /\S/,
                    inputErrorMessage: '用户组名称不能为空'
                }).then(({value}) => {
                    CustomerGroupService.create({
                        customer_id: this.$route.query['id'],
                        name: value,
                        service: 'xwt'
                    }).then(res => {
                        if (res.code == 0) {
                            this.options.push({
                                id: res.data.id,
                                name: value,
                            });
                            this.currentOption = res.data.id;
                        }
                    })
                });
            },
            /**
             * 提交
             * */
            submit(expire_type = '') {
                this.$refs['form'].validate((valid,dd) => {
                    this.check_box_config = valid;
                    if (!valid) {
                        if(dd['single_account_time_setting']){
                            this.$message({
                                message: _.head(dd['single_account_time_setting']).message,
                                type: 'error'
                            });
                        }
                        return false;
                    }
                });
                if(!this.check_box_config) return false;
                if(this.$refs[this.currentOption]){
                    this.$refs[this.currentOption].validateForm((valid) => {
                           this.check_box_config = valid
                    })
                }


                //this.form.box_setting.id = this.currentOption;
                // 如果有车厢设置
                if (typeof this.form.box_setting == 'object') {
                    this.form.box_setting.id = this.currentOption;
                }

                if (this.is_submit) return false;
                this.is_submit = true;
                
                this.form.expire_type = expire_type;
                console.log('submit:',this.form);
                OrderService.reviseProduct(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.msg == 'success' ? Params.REVISE_NOTICE : res.msg,
                            type: 'success'
                        });
                    }
                    this.is_temporary = false;
                    this.is_submit = false;
                }).catch(err => {
                    this.is_submit = false;
                    console.error(err);
                });
            },
            updateBoxForm(form) {
                this.form.box_setting = form;
            },
            noZero(v){
                if(v==0){
                    this.$message({
                        message: '不能为0',
                        type: 'error'
                    });
                    return false;
                }
            },
            getOptions() {
                CustomerGroupService.getList({customer_id: this.params.customer_id, service: 'xwt'}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.options = res.data;
                        this.currentOption = this.options[0]['id'];
                    }
                    this.loading = false;
                })
            },

        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/xwtConfigure.vue